import { Controller } from "@hotwired/stimulus";

const MOBILE_IP_PREFIXES = ["050", "070", "080", "090"];
const TWO_DIGIT_AREA_CODES = ["03", "06"];
const TOLL_FREE_PREFIXES = ["0120"];
const INVALID_MESSAGE = "有効な電話番号を入力してください";
const LENGTH_MESSAGE = "電話番号は10桁または11桁の半角数字で入力してください";

export default class extends Controller {
  connect() {
    this.applyValidity(this.element);
    this.element.dispatchEvent(new Event("input", { bubbles: true }));
  }

  validate(e) {
    this.applyValidity(e.target);
  }

  applyValidity(input) {
    const value = input.value;
    if (!value) {
      input.setCustomValidity("");
      return;
    }
    if (!/^\d{10,11}$/.test(value)) {
      input.setCustomValidity(LENGTH_MESSAGE);
      return;
    }
    input.setCustomValidity(this.isValid(value) ? "" : INVALID_MESSAGE);
  }

  isValid(value) {
    if (!/^\d{10,11}$/.test(value)) return false;
    if (/^(\d)\1+$/.test(value)) return false;
    if (TOLL_FREE_PREFIXES.some((p) => value.startsWith(p))) return false;

    if (value.length === 11) {
      return MOBILE_IP_PREFIXES.includes(value.slice(0, 3));
    }
    if (value.length === 10) {
      if (TWO_DIGIT_AREA_CODES.includes(value.slice(0, 2))) return true;
      if (MOBILE_IP_PREFIXES.includes(value.slice(0, 3))) return false;
      return /^0[1-9]\d{8}$/.test(value);
    }
    return false;
  }
}
